// Dynamically loads an external script on demand and caches the result.
//
// Returns a Promise that resolves once the script has loaded (for UMD bundles
// this is also when their global has been defined). Repeat calls for the same
// `src` reuse the in-flight or resolved promise, so a script is only ever
// fetched and executed once. A failed load clears the cache so a later call
// can retry.

const scriptPromises = {};

export default function loadScript(src, attributes = {}) {
  if (scriptPromises[src]) {
    return scriptPromises[src];
  }

  scriptPromises[src] = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    Object.keys(attributes).forEach((key) => {
      script.setAttribute(key, attributes[key]);
    });
    script.onload = () => resolve();
    script.onerror = () => {
      delete scriptPromises[src];
      script.remove();
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.body.appendChild(script);
  });

  return scriptPromises[src];
}
